import { render } from "./FooterNavi.vue?vue&type=template&id=a0b20ce6&scoped=true"
const script = {}

import "./FooterNavi.vue?vue&type=style&index=0&id=a0b20ce6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b20ce6"]])

export default __exports__